const colorsDictionary = {
  channelname: {
    'socket': 'rgba(229, 7, 112, 1)',
    'socketsdk': 'rgba(229, 7, 112, 1)',
    'apple': '#2997ff',
    'rbm': '#fbbc05',

    'messenger': '#0084ff',
    'facebook': '#0084ff',

    'rocketchat': '#d0db00',
    'liveperson': '#b147b5',
    'khoros': '#00004B',
    'mavenir': '#005B92',
    'telegram': '#0088cc',
    'twilio': '#cc3131',
    'twitter': '#1da1f2',
    'slack': '#72C5CD',
    'messagemedia': '#33bbed',
    'alexa': '#01CAFF',
    'viber': '#9b24c9',
    'voip': 'rgba(229, 7, 112, 1)',
    'sparkcentral': '#3E8EDE',
    'wit': '#de4028',
    'front': '#FF0C64',
    'rest': 'rgba(229, 7, 112, 1)',
    'kik': '#248c4a',
    'socket_sdk': 'rgba(229, 7, 112, 1)',

    'telekom': '#E2007A',

    'whatsapptest': '#25d366',
    'whatsapp': '#25d366'
  },
  'originatorrole': {
    'SYSTEM': '#25d366',
    'BOT': '#25d366',
    'USER': '#2997ff',
    'EXTERNAL': '#AA63F8',
    'MODERATOR': '#16BCAF'
  },
  eventname: {
    'USER_NEW': '#2997ff',
    'USER_OLD': '#25d366'
  }
}

export default colorsDictionary
